import React from 'react';
import { Navigate } from 'react-router-dom';
import { hasRoutePermission, getCurrentUserPermissions } from '../utils/permissions';

/**
 * Componente para proteger rutas según permisos del usuario
 * @param {Object} props
 * @param {React.ReactNode} props.children - Componente a renderizar si tiene permiso
 * @param {String} props.requiredPermission - Permiso específico requerido (opcional)
 */
const ProtectedRoute = ({ children, requiredPermission = null }) => {
  const userPermissions = getCurrentUserPermissions();
  const currentPath = window.location.pathname;

  // Si no hay permisos (no autenticado), redirigir al login
  if (!userPermissions || userPermissions.length === 0) {
    return <Navigate to="/" replace />;
  }

  // Rutas que siempre son accesibles
  const publicRoutes = ['/dashboard', '/change-password'];
  if (publicRoutes.includes(currentPath)) {
    return children;
  }

  // Si requiere un permiso específico
  if (requiredPermission) {
    const permissionNames = userPermissions.map(p => 
      p.PERMISO_NOMBRE || p.permiso_nombre || p.nombre || p.name || p
    );
    
    // Administrador tiene acceso a todo
    if (permissionNames.includes('Administrador')) {
      return children;
    }

    // Verificar si tiene el permiso específico
    if (!permissionNames.includes(requiredPermission)) {
      return <Navigate to="/dashboard" replace />;
    }

    return children;
  }

  // Verificar si tiene permiso para esta ruta
  const hasPermission = hasRoutePermission(userPermissions, currentPath);

  if (!hasPermission) {
    // No tiene permiso, redirigir al dashboard
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;
